import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage/Homepage";
import SchoolProjects from "./pages/SchoolProjects/SchoolProjects";
import TweekrachtApp from "./pages/SchoolProjects/TweekrachtApp";
import FontysMarketingCampaign from "./pages/SchoolProjects/FontysMarketingCampaign";
import JewelleryWebshop from "./pages/SchoolProjects/JewelleryWebshop";
import SeptemberpleinApp from "./pages/SchoolProjects/SeptemberpleinApp";
import PersonalProjects from "./pages/PersonalProjects/PersonalProjects";
import InventoryManagementApp from "./pages/PersonalProjects/InventoryManagementApp";
import PingPongCoachApp from "./pages/PersonalProjects/PingPongCoach";

import Facemodel3D from "./pages/PersonalProjects/Facemodel3D";
import Branding from "./pages/PersonalProjects/Branding";
import LO1 from './pages/Learning Outcome/LO1';
import Work from './pages/Work';
// import Contact from './pages/Contact';
import About from './pages/About';
import Navbar from './assets/Navbar/Navbar';
import WorkGroupLogo from './pages/WorkPages/Work-Group-Logo';
import WorkGroupName from './pages/WorkPages/Work-Group-Name';
import WorkGroupArtworks from './pages/WorkPages/Work-Group-Artworks';
import WorkProcessPortfolio from './pages/WorkPages/Work-Process-Portfolio';
import LO2 from './pages/Learning Outcome/LO2';
import LO3 from './pages/Learning Outcome/LO3';
import LO4 from './pages/Learning Outcome/LO4';
import LO5 from './pages/Learning Outcome/LO5';
import Content from './assets/Content/Content';
import WorkPosters from './pages/WorkPages/Work-Posters';
import WorkVideolab from './pages/WorkPages/Work-Videolab';
import WorkClient from './pages/WorkPages/Work-Client';
import WorkCareer from './pages/WorkPages/Work-Career';
import Lo5AttendingEvents from './pages/Learning Outcome/LO5-Attending-Events';
import Lo5Feedback from './pages/Learning Outcome/LO5-Feedback';
import Lo5Job from './pages/Learning Outcome/LO5-Job';
import Lo5Self from './pages/Learning Outcome/LO5-Self';
import Lo2Git from './pages/Learning Outcome/LO2-Git';
import Lo2ReadGit from './pages/Learning Outcome/LO2-ReadGit';
import Lo2Commit from './pages/Learning Outcome/LO2-Commit';
import Lo2Doc from './pages/Learning Outcome/LO2-Documentation';
import Lo1Target from './pages/Learning Outcome/LO1-Target';
import Lo1Concept from './pages/Learning Outcome/LO1-Concept';
import Lo1Design from './pages/Learning Outcome/LO1-Design';
import Lo1Product from './pages/Learning Outcome/LO1-Product';
import Lo3Clear from './pages/Learning Outcome/LO3-Clear';
import Lo3Reason from './pages/Learning Outcome/LO3-Reason';
import Lo3Before from './pages/Learning Outcome/LO3-Before';
import Lo3Valid from './pages/Learning Outcome/LO3-Validation';
import Lo4HMW from './pages/Learning Outcome/LO4-HMW';
import Lo4Sum from './pages/Learning Outcome/LO4-Summary';
import Lo4Adv from './pages/Learning Outcome/LO4-Advisory';
import Lo4Res from './pages/Learning Outcome/LO4-Research';
import Lo4Conc from './pages/Learning Outcome/LO4-Conclusion';
import WorkMascot from './pages/WorkPages/Work-Mascot';
import Work3D from './pages/WorkPages/Work-3D';
import Lo4Scrum from './pages/Learning Outcome/LO4-Scrum';
import Lo4Eth from './pages/Learning Outcome/LO4-Ethical';
import Lo1User from './pages/Learning Outcome/LO1-User';
import Lo5Reflections from './pages/Learning Outcome/LO5-Reflection';
import JavaScriptPractice from './pages/PersonalProjects/Jspractice';



function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Homepage />} />

        {/* LO1 and subpages nested under lo1 */}
        <Route path='lo1' element={<LO1 />} />
        <Route path='lo1/targetaudience' element={<Lo1Target />} />
        <Route path='lo1/concept' element={<Lo1Concept />} />
        <Route path='lo1/designproofofconcept' element={<Lo1Design />} />
        <Route path='lo1/interactiveproduct' element={<Lo1Product />} />
        <Route path='lo1/userstories' element={<Lo1User />} />


        {/* LO2 */}
        <Route path='lo2' element={<LO2 />} />
        <Route path='lo2/git' element={<Lo2Git />} />
        <Route path='lo2/readgit' element={<Lo2ReadGit />} />
        <Route path='lo2/commitandbranches' element={<Lo2Commit />} />
        <Route path='lo2/codedocumentation' element={<Lo2Doc />} />

        {/* LO3 */}
        <Route path='lo3' element={<LO3 />} />
        <Route path='lo3/clearstartingpoints' element={<Lo3Clear />} />
        <Route path='lo3/reasonforiteration' element={<Lo3Reason />} />
        <Route path='lo3/beforeandafter' element={<Lo3Before />} />
        <Route path='lo3/validation' element={<Lo3Valid />} />
        <Route path='lo3/iterationonmultipleareas' element={<Lo3Reason />} />

        {/* LO4 */}
        <Route path='lo4' element={<LO4 />} />
        <Route path='lo4/hmw' element={<Lo4HMW />} />
        <Route path='lo4/summaryprocess' element={<Lo4Sum />} />
        <Route path='lo4/advisoryreport' element={<Lo4Adv />} />
        <Route path='lo4/research' element={<Lo4Res />} />
        <Route path='lo4/conclusion' element={<Lo4Conc />} />
        <Route path='lo4/scrum' element={<Lo4Scrum />} />
        <Route path='lo4/ethical' element={<Lo4Eth />} />


        {/* LO5 */}
        <Route path='lo5' element={<LO5 />} />
        <Route path='lo5/attendingevents' element={<Lo5AttendingEvents />} />
        <Route path='lo5/feedback' element={<Lo5Feedback />} />
        <Route path='lo5/job' element={<Lo5Job />} />
        <Route path='lo5/self' element={<Lo5Self />} />
        <Route path='lo5/reflection' element={<Lo5Reflections />} />



        {/* Other pages */}
        <Route path='school-projects' element={<SchoolProjects />} />
        <Route path='school-projects/tweekrachtapp' element={<TweekrachtApp />} />
        <Route path='school-projects/fontys-marketing-campaign' element={<FontysMarketingCampaign />} />
        <Route path='school-projects/jewellery-webshop' element={<JewelleryWebshop />} />
        <Route path='school-projects/septemberplein-app' element={<SeptemberpleinApp />} />
        <Route path='personal-projects' element={<PersonalProjects />} />
        <Route path='personal-projects/inventory-management-app' element={<InventoryManagementApp />} />
        <Route path='personal-projects/pingpong-coach-app' element={<PingPongCoachApp />} />
        <Route path='personal-projects/facemodel-3d' element={<Facemodel3D />} />
        <Route path='personal-projects/branding' element={<Branding />} />
        <Route path='personal-projects/jspractice' element={<JavaScriptPractice />} />
        <Route path='about' element={<About />} />
        <Route path='work' element={<Work />} />
        <Route path='workposters' element={<WorkPosters />} />
        <Route path='workvideolab' element={<WorkVideolab />} />
        <Route path='workclient' element={<WorkClient />} />
        <Route path='workcareer' element={<WorkCareer />} />
        <Route path='grouplogo' element={<WorkGroupLogo />} />
        <Route path='groupname' element={<WorkGroupName />} />
        <Route path='groupartworks' element={<WorkGroupArtworks />} />
        <Route path='processportfolio' element={<WorkProcessPortfolio />} />
        <Route path='mascot' element={<WorkMascot />} />
        <Route path='3d' element={<Work3D />} />
      </Routes>
    </Router>
  );
}

export default App;
